/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PasswordRules/view.blocks to change it.
import EightCharsOrMore from './EightCharsOrMore/index'
import OneCapitalLetter from './OneCapitalLetter/index'
import OneLowerCaseLetter from './OneLowerCaseLetter/index'
import OneNumber from './OneNumber/index'
import OneSpecialChar from './OneSpecialChar/index'
import React from 'react'
import TysiaInputHelp from 'DesignSystem/TysiaInput/TysiaInputHelp/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function PasswordRules({
  children,
  viewPath = "/App/Auth/ResetPasswordConfirm/PasswordRules"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="PasswordRules.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaInputHelp
  viewPath={`${viewPath}/TysiaInputHelp`}
 text="Make sure the password meets the following requirements:"
/>
<EightCharsOrMore
  viewPath={`${viewPath}/EightCharsOrMore`}
/>
<OneNumber
  viewPath={`${viewPath}/OneNumber`}
/>
<OneCapitalLetter
  viewPath={`${viewPath}/OneCapitalLetter`}
/>
<OneLowerCaseLetter
  viewPath={`${viewPath}/OneLowerCaseLetter`}
/>
<OneSpecialChar
  viewPath={`${viewPath}/OneSpecialChar`}
/>
</div>
{children}
</React.Fragment>)
}